module.exports = "<div class=\"introduction {{projectName}}\">\n  <div class=\"container\">\n    <h1> {{ projectName }} </h1>\n    <hr>\n    <p> {{ projectIntro }}\n  </div>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/portfolio-intro/portfolio-intro.component.html
// module id = ./src/app/shared/portfolio-intro/portfolio-intro.component.html
// module chunks = main